import { Box, Chip, Dialog, DialogContent, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { IoMdCloseCircle, IoMdCloseCircleOutline } from 'react-icons/io'
import { cn } from 'src/lib/utils'

import { Worker, Viewer } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

const RiskInformation = ({ RiskDetailsById }) => {
    const loginId = localStorage.getItem('userId')
    const [ isSeeDetailed, setIsSeeDetailed ] = useState(false)
    const [ showPdf, setShowPdf ] = useState(false)
    const [ pdfBase64, setPdfBase64 ] = useState({})
    const defaultLayoutPluginInstance = defaultLayoutPlugin()

    const loadPdf = (data) => {
        setPdfBase64(data)
        setShowPdf(true)
    }

    const handlePDFModelClose = () => {
        setShowPdf(false)
        setPdfBase64({})
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === 'Controlled') {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === 'Low') {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === 'Medium') {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === 'High') {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === 'Extreme') {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }
    return (
        <div className='h-full w-full'>
            <Box p={2} sx={{}}>
                <Typography variant="h6" className='!text-subHeading-2' sx={{ p: 1.5, borderRadius: '10px', color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))' }}>Risk Summary</Typography>
                <Grid container spacing={2} alignItems="center" sx={{ py: 4, px: 2, borderBottom: '2px solid hsl(var(--primary-foreground))' }}>
                    <Grid sx={{ marginRight: '25px' }} item>
                        <div className='text-primary !text-subHeading-2'>{'Raised by'}</div>
                        <div className='!text-b5 text-muted'>{Number(loginId) === Number(RiskDetailsById?.createdBy) ? 'You' : RiskDetailsById?.name}</div>
                    </Grid>
                    <Grid sx={{ marginRight: '25px' }} item>
                        <div className='text-primary !text-subHeading-2'>Role</div>
                        {RiskDetailsById?.roles?.filter((filterData, filterIdx) => filterData !== null)?.map((mapDt, mapIdx) => <Chip key={mapIdx} label={mapDt} sx={{ height: '20px', mt: 1, backgroundColor: 'hsl(var(--Risk))', color: 'hsl(var(--card))', mr: 1 }} />)}
                    </Grid>
                    <Grid sx={{ marginRight: '25px' }} item>
                        <div className='text-primary !text-subHeading-2'>Designation</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.designation}</div>
                    </Grid>
                    <Grid sx={{ marginRight: '25px' }} item>
                        <div className='text-primary !text-subHeading-2'>Department</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.department}</div>
                    </Grid>
                    <Grid sx={{ marginRight: '25px' }} item>
                        <div className='text-primary !text-subHeading-2'>Created Date</div>
                        <div className='!text-b5 text-muted'>{dayjs(RiskDetailsById?.createdAt).format('MMM DD, YYYY')}</div>
                    </Grid>
                </Grid>
                <Grid container alignItems="center" sx={{ py: 4, px: 2, alignItems: 'baseline' }} spacing={4}>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Risk Title</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.title}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Description</div>
                        <div className='!text-b5 break-words text-muted'>{RiskDetailsById?.description}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Identified On</div>
                        <div className='!text-b5 text-muted'>{dayjs(typeof RiskDetailsById?.identifiedOn === 'string' ? new Date(RiskDetailsById?.identifiedOn) : RiskDetailsById?.identifiedOn).format('MMM DD, YYYY')}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Source of Risk</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.sourceRiskId}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Risk Nature</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.type}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Category</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.category}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Impacted Department</div>
                        <div className='!text-b5 text-muted break-words whitespace-normal'>{RiskDetailsById?.impactedDepartment?.join(',')}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className='text-primary !text-subHeading-2'>Risk Owner</div>
                        <div className='!text-b5 text-muted'>{RiskDetailsById?.ownerDepartmentId}</div>
                    </Grid>
                </Grid>
                <Box alignItems="center" sx={{ p: 2 }} mt={4}>
                    <div className='text-primary !text-subHeading'>Supporting Documents</div>
                    <Box sx={{ p: 1, display: 'flex', flexDirection: 'row' }}>
                        {RiskDetailsById?.supportingDocuments?.length > 0
                            ? RiskDetailsById?.supportingDocuments?.map((mapData, mapIdx) => <Box onClick={() => loadPdf(mapData)} key={mapIdx} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', mr: 1 }}>
                                <AiOutlineFilePdf style={{ color: 'red', marginRight: '8px' }} />
                                <div className="text-primary" color="hsl(var(--primary))" style={{ textDecoration: 'underline', cursor: 'pointer' }}>{mapData?.fileName}</div></Box>)
                            : <p className='font-bold text-primary'>-</p>}
                    </Box>
                </Box>
                <Typography variant="h6" className='!text-subHeading-2' sx={{ p: 1.5, borderRadius: '10px', color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))' }}>Risk Scoring</Typography>
                <Grid container alignItems="center" sx={{ p: 2 }} spacing={4}>
                    <Grid item xs={8}>
                        <div className='py-[20px]'>
                            <table className="risk-table">
                                <thead >
                                    <tr>
                                        <th>Users</th>
                                        <th>Impact</th>
                                        <th>Probability</th>
                                        <th>Risk Level</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {RiskDetailsById?.riskScore?.map((mapDt, mapKey) => {
                                        return (<tr key={mapKey}>
                                            <td className='flex flex-col justify-center'>
                                                <span>{Number(loginId) === Number(RiskDetailsById?.createdBy) ? 'You' : mapDt?.user || '-'}</span>
                                                <span className='text-destructive'>{mapDt?.role || '-'}</span>
                                            </td>
                                            <td>{mapDt?.impact || '-'}</td>
                                            <td>{mapDt?.probability || '-'}</td>
                                            <td>
                                                {mapDt?.riskScore ? <span className={'risk-level'} style={{ backgroundColor: chipColorStyle(mapDt?.riskScore) }}>{mapDt?.riskScore || '-'}</span> : '-'}
                                            </td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid container alignItems="center" sx={{ px: 4 }} spacing={4}>
                        {RiskDetailsById?.riskScore?.map((mapDt, mapKey) => <Grid key={mapKey} item xs={4}>
                            <div className='text-primary text-subHeading-2'>{`Impact of Risk (${mapDt?.user})`}</div>
                            <div className='!text-b5 text-muted'>{mapDt?.impactOfRisk}</div>
                        </Grid>)}
                    </Grid>
                </Grid>
                <Typography variant="h6" className='!text-subHeading-2' sx={{ p: 1.5, borderRadius: '10px', color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))' }}>Suggested Mitigation</Typography>
                <Grid container alignItems="center" sx={{ p: 2 }} spacing={4}>
                    {isSeeDetailed && <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                        <p className='font-bold'><span className='text-muted'>Raised By : </span><span className='text-primary'>{RiskDetailsById?.name}</span></p>
                    </Grid>}
                    {isSeeDetailed && <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                        <p className='font-bold'><span className='text-muted'>Raised Department Manager : </span><span className='text-primary'>{RiskDetailsById?.raisedName}</span></p>
                    </Grid>}
                    {isSeeDetailed && <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                        <p className='font-bold'><span className='text-muted'>Owned Department Manager : </span><span className='text-primary'>{RiskDetailsById?.ownerName}</span></p>
                    </Grid>}
                    <Grid item xs={12}>
                        {isSeeDetailed
                            ? <div className='w-[100%]'>
                                <table className="risk-table w-[100%]">
                                    <thead className="w-[100%]">
                                        <tr className="w-[100%]">
                                            <th className="w-[10%]"><div className='flex flex-col justify-center items-center'>S.No</div></th>
                                            <th className="w-[30%]">Task</th>
                                            <th className="w-[10%]">Start Date</th>
                                            <th className="w-[10%]">End Date</th>
                                            <th className="w-[10%]">Created By</th>
                                            <th className="w-[15%]">{RiskDetailsById?.raisedName}</th>
                                            <th className="w-[15%]">{RiskDetailsById?.ownerName}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="w-[100%]">
                                        {RiskDetailsById?.suggestedMitigation?.map((mapDt, mapIdx) => {
                                            const showRaisedReject =
                                        mapDt.actions === 11 && mapDt.modifiedBy === RiskDetailsById.raisedId
                                            const showOwnerReject =
                                        mapDt.actions === 11 && mapDt.modifiedBy === RiskDetailsById.ownerId

                                            return (
                                                <tr className="w-[100%]" key={mapIdx}>
                                                    <td className="w-[10%]">
                                                        <div style={{ borderLeft: `8px solid ${mapDt.actions === 11 ? 'hsl(var(--destructive))' : 'hsl(var(--Low))'}` }} className='my-[-12px] mx-[-16px] py-[12px] px-[16px] flex flex-col justify-center items-center'>
                                                            <span className='h-[30px] w-[30px] bg-primary-foreground rounded-full flex flex-col justify-center items-center'>{mapIdx + 1}</span>
                                                        </div>
                                                    </td>
                                                    <td className="w-[40%] text-nowrap">{mapDt?.name || '-'}</td>
                                                    <td><span className=''>{dayjs(mapDt?.startDate)?.format('DD/MM/YYYY') || '-'}</span></td>
                                                    <td><span className=''>{dayjs(mapDt?.endDate)?.format('DD/MM/YYYY') || '-'}</span></td>
                                                    <td className="w-[15%] text-nowrap">{mapDt?.createdName || '-'}</td>
                                                    <td className="w-[15%]">
                                                        <div className='flex flex-col justify-center items-center'>
                                                            {showRaisedReject
                                                                ? (
                                                                    <IoMdCloseCircle color='hsl(var(--destructive))' size={20} />
                                                                )
                                                                : (
                                                                    mapDt.actions === null && <span>-</span>
                                                                )}
                                                        </div>
                                                    </td>
                                                    <td className="w-[20%]">
                                                        <div className='flex flex-col justify-center items-center'>
                                                            {showOwnerReject
                                                                ? (
                                                                    <IoMdCloseCircle color='hsl(var(--destructive))' size={20} />
                                                                )
                                                                : (
                                                                    mapDt.actions === null && <span>-</span>
                                                                )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            : <div className='w-[100%]'>
                                <table className="risk-table w-[100%]">
                                    <thead className='w-[100%]'>
                                        <tr className='w-[100%]'>
                                            <th className='w-[20%] '><span className='flex flex-col justify-center items-center'>S.No</span></th>
                                            <th className='w-[50%]'>Task</th>
                                            <th className='w-[15%]'>Start Date</th>
                                            <th className='w-[15%]'>End Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className='w-[100%]'>
                                        {RiskDetailsById?.suggestedMitigation?.map((mapDt, mapIdx) => {
                                            return (
                                                <tr className='w-full' key={mapIdx}>
                                                    <td className='text-nowrap'><span className='my-[-12px] mx-[-16px] py-[12px] px-[16px] flex flex-col justify-center items-center' style={{ borderLeft: `8px solid ${mapDt.actions === 11 ? 'hsl(var(--destructive))' : 'hsl(var(--Low))'}` }}>{mapIdx + 1}</span></td>
                                                    <td><span className=''>{mapDt?.name || '-'}</span></td>
                                                    <td><span className=''>{dayjs(mapDt?.startDate)?.format('DD/MM/YYYY') || '-'}</span></td>
                                                    <td><span className=''>{dayjs(mapDt?.endDate)?.format('DD/MM/YYYY') || '-'}</span></td>
                                                </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>}
                        {RiskDetailsById?.status !== 1 && <div className='w-[100%] pt-4 flex flex-row justify-end'>
                            <p onClick={() => setIsSeeDetailed(!isSeeDetailed)} className={cn('underline underline-offset-2 cursor-pointer text-primary')}>{isSeeDetailed ? 'Hide Detailed' : 'See Detailed'}</p>
                        </div>}
                    </Grid>
                </Grid>
            </Box>
            <Dialog
                open={showPdf}
                onClose={handlePDFModelClose}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent style={{ height: '1050px' }}>
                    <div className='w-full flex flex-col mt-[-10px] mb-[10px] justify-end items-end'>
                        <IoMdCloseCircleOutline className='cursor-pointer' onClick={handlePDFModelClose} color='hsl(var(--muted))' size={25}/>
                    </div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={`data:${pdfBase64?.contentType};base64,${pdfBase64?.file}`}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default RiskInformation
